// YERİ: src/app/domains/site/sections/stats.section.ts
// İstatistik bandı — primary arka plan üzerinde sayaçlar.

import { Component, computed, input } from '@angular/core';
import { SiteConfig, cfg } from './section.model';

interface StatItem { value: string; label: string; }

@Component({
  selector: 'sec-stats',
  standalone: true,
  template: `
    <section id="stats" class="py-20" style="background:linear-gradient(135deg,var(--site-primary),var(--site-primary-dark))">
      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="grid grid-cols-2 gap-8 text-center lg:grid-cols-4">
          @for (s of items(); track s.label) {
            <div [class.flex]="labelTop()" [class.flex-col-reverse]="labelTop()">
              <p class="font-[family-name:var(--site-head-font)] text-4xl font-bold text-white sm:text-5xl">{{ s.value }}</p>
              <p class="mt-2 text-sm font-medium uppercase tracking-wider text-white/70">{{ s.label }}</p>
            </div>
          }
        </div>
      </div>
    </section>
  `,
})
export class StatsSection {
  config = input<SiteConfig>({});
  /** label-top → etiket üstte, değer altta (flex-col-reverse ile). */
  protected labelTop = computed(() => cfg<string>(this.config(), 'order', 'value-top') === 'label-top');
  protected items = computed<StatItem[]>(() => cfg<StatItem[]>(this.config(), 'items', [
    { value: '1500+', label: 'Sonuçlanan Dava' },
    { value: '%95', label: 'Başarı Oranı' },
    { value: '20+', label: 'Yıllık Tecrübe' },
    { value: '800+', label: 'Mutlu Müvekkil' },
  ]));
}
